











import {Component, Mixins, Vue, Watch} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import {GOOGLE_MAPS_KEY, nil} from '@/common';
import LocationMixin from '@/mixins/LocationMixin.vue';
import WhiteListedLocationsDialog from "@/components/Pages/Booking Flow/WhiteListedLocationsDialog.vue";

@Component({
    components: {
        WhiteListedLocationsDialog
    },
})
export default class BookingChooseLocation extends Mixins(LocationMixin) {
    @Sync('booking/step') private bookingStep!: number;
    @Sync('packages/step') public packageStep!: number;
    public locationUnsupportedDialogOpen = false;

    @Watch('formattedAddress')
    private onLocationChanged(value: string, oldValue: string) {
        if (!nil(value)) {
            window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    actionField:{'step':1}
                }
            });
            this.packageMode
            ? this.packageStep++
            : this.bookingStep++;
        }
    }

    public mounted() {
        this.$bus.$on('location_not_supported', (data) =>{
            this.$refs.unsupportedLocationsDialog.open();
        });
        this.setupAddressInputs();
        this.packageMode
        ? this.packageStep = 1
        : this.bookingStep = 1;
    }

    get packageMode() {
        return this.$route.path.indexOf('package') > -1;
    }

}
